import { Grid } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import WSDataGrid, { IColumns } from "../../Components/DataGrid/WSDataGrid";
import WSMobileDataGridAdvanced, { IOrderColumns } from "../../Components/DataGrid/WSMobileDataGridAdvanced";
import { IsSmallScreen, MasterPages } from "../../commonFunctions/CommonFunctions";
import PermissionDenied from "../../commonFunctions/PermissionDenied";
import { AllPermissions, getPermissions } from "../../commonFunctions/PermissionManger";

export const CallLogList: React.FC<any> = React.memo((props) => {
    AllPermissions.getInstance();
    const { add,edit,remove, view} =AllPermissions.getCallPermission;
    const navigate = useNavigate();
    const isMobile = IsSmallScreen();
    const source = {
        url: "call-logs/search",
        page: 1,
        pageSize: 10,
        filter: [
        ],
        sort: [],
    };

    /**
     * Edit function
     * @param action 
     * @param row 
     */
    const handleAction = async (action: string, row: any) => {
        if (action === "Edit") {
            navigate(`/call/edit/${row?.id}`)
        }

    };
    const columns: IColumns[] = [
        {
            header: "Subject",
            fieldName: "subject",
            tooltip: true,
            type: 'default'
        },
        {
            header: "Type",
            fieldName: "callType",
            tooltip: true,

            type: 'default'
        },
        {
            header: "Start",
            fieldName: "callStart",
            tooltip: true,
            type: 'dateTime'
        },
        {
            header: "callStatus",
            fieldName: "callStatus",
            tooltip: true,
            type: 'status'
        },
        {
            header: "Actions",
            fieldName: "actions",
            type: "action",
            actions: [edit ? "Edit" : undefined].filter(Boolean),
            actionCallback: (action, row) => handleAction(action, row),

        },
    ];
    const mobColumns: IOrderColumns[] = [
        {
            header: "Subject",
            fieldName: "subject",
            tooltip: true,
            type: 'default',
            labelSx:{fontWeight:'bold'}
        },
        {
            header: "Type",
            fieldName: "callType",
            tooltip: true,

            type: 'default'
        },
        {
            header: "callStatus",
            fieldName: "callStatus",
            tooltip: true,

        },
        {
            header: "Start",
            fieldName: "callStart",
            tooltip: true,
            type: 'date',
            labelSx:{marginLeft:2},
            sm:8,
            isBoderRadious:true
        },
      
        {
            header: "Actions",
            fieldName: "actions",
            type: "action",
            actions: [edit ? "Edit" : undefined].filter(Boolean),
            actionCallback: (action, row) => handleAction(action, row),

        },
    ];
    const handleClick = () => {
        navigate('/call/create')
    }
    return (
        <>
            <Grid container spacing={2}>
                {view ? <Grid item xs={12}>
                    {!isMobile && <WSDataGrid
                        id="callLogMainListGrid"
                        title="Calls"
                        columns={columns}
                        source={source}
                        addButton={{ label: 'New', color: 'secondary', }}
                        onAddButtonClick={handleClick}
                        gridHeaderSx={{ backgroundColor: 'whitesmoke', border: '1px solid whitesmoke' }}
                    />
                    }
                    {isMobile &&
                        <WSMobileDataGridAdvanced title={'Calls'} addButton={add ? { label: "New", color: "secondary" } : undefined}
                            onAddButtonClick={handleClick} columns={mobColumns} id="callLogMainListGrid" source={source} />
                    }
                </Grid>
                    : <PermissionDenied />}
            </Grid>
        </>
    )
})